import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MdFolder } from 'react-icons/md';

export const UploadStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
});

export const IconFolderStyled = styled(Box)(({ theme }) => ({
  height: 42,
  width: 42,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.global.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 5,
}));

export const IconStyled = styled(MdFolder)({
  fontSize: 20,
  '&:hover': {
    fontSize: 32,
  },
});

export const UploadLogoStyled = styled('div')(({ theme }) => ({
  width: '80%',
  height: 42,
  border: `1px dashed ${theme.palette.global.lightgray}`,
  borderRadius: 5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const ButtonPrimaryStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.global.white,
  fontWeight: 'bold',
  width: 200,
  height: 48,
}));

export const ButtonSecondaryStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.global.lightgray,
  fontWeight: 'bold',
  width: 200,
  height: 48,
}));
